// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Q_lr","buttons":"styles_buttons__1_eD1"};